export default "__VITE_ASSET__BYF1n5DD__"